/* eslint object-curly-newline: */
import { connect } from 'react-redux';
import NodeHealthSelectorComponent from './../Components/NodeHealthSelectorComponent';

import { nodeIssues as nodeIssueActions } from '../actions';
import { nodeIssues as nodeIssueSelectors } from '../selectors';
import { nodeHealthPageReducer } from '../reducers';

export const mapStateToProps = (state) => {
  const props = {
    availableNodes: nodeIssueSelectors.nodesWithActiveIssues(state),
    availableIssues: nodeIssueSelectors.activeNodeIssueTypeIds(state)
      .map(name => name || 'unknown'),
    availableJobNames: nodeIssueSelectors.activeNodeIssueJobNames(state),
    nodeHealthInfo: nodeHealthPageReducer.getNodeHealthInfo(state)
  };
  return props;
};

export const mapDispatchToProps = (dispatch) => {
  const props = {
    onSelectorChange: (model) => {
      dispatch(nodeIssueActions.setNodeIssuesFiltered(model));
      dispatch(nodeIssueActions.setNodeIssuesSelectedForAck([]));
    }
  };
  return props;
};

export default connect(mapStateToProps, mapDispatchToProps)(NodeHealthSelectorComponent);


// WEBPACK FOOTER //
// src/Containers/NodeHealthSelectorContainer.jsx